export function formConfig(state = null, action) {
  switch (action.type) {
    case 'FULFILL_FORM_CONFIG':
      return action.payload;
    default:
      return state;
  }
}

export function companyDetails(state = {}, action) {
  switch (action.type) {
    case 'FULFILL_FORM_CONFIG':
      return action.companyDetails;
    default:
      return state;
  }
}

export function dropdownLists(
  state = {
    propertyType: [],
    reportPurpose: [],
    reportType: [],
    inspectionTypes: [],
    valueApproaches: [],
  },
  action,
) {
  switch (action.type) {
    case 'FULFILL_DROPDOWN_LISTS':
      return {
        propertyType: action.propertyType,
        reportPurpose: action.reportPurpose,
        reportType: action.reportType,
        inspectionTypes: action.inspectionTypes,
        valueApproaches: action.valueApproaches,
      };
    default:
      return state;
  }
}

export function paymentDetails(
  state = {
    clientSecret: null,
    paymentOptions: [],
    requiresPreAuthorizedPayment: false,
  },
  action,
) {
  switch (action.type) {
    case 'FULFILL_PAYMENT_DETAILS':
      return {
        ...state,
        paymentOptions: action.paymentOptions,
        clientSecret: action.clientSecret,
      };
    case 'UPDATE_PAYMENT_DETAILS':
      return {
        ...state,
        paymentOptions: action.paymentOptions,
      };
    case 'REMOVE_PAYMENT_ID':
      return {
        ...state,
        paymentOptions: state.paymentOptions.filter(
          ({ paymentMethodId }) => action.paymentId !== paymentMethodId,
        ),
      };
    case 'FULFILL_FORM_CONFIG':
      return {
        ...state,
        requiresPreAuthorizedPayment: action.requiresPreAuthorizedPayment,
        guestRequiresPreAuthorizedPayment: action.guestRequiresPreAuthorizedPayment,
      };
    default:
      return state;
  }
}
